import { DecimalPipe } from '@angular/common';
import { Component, HostListener, computed, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { BagUiService } from '../../core/services/bag-ui.service';
import { CartLine, CartService } from '../../core/services/cart.service';

@Component({
  selector: 'app-bag-drawer',
  imports: [RouterLink, DecimalPipe],
  templateUrl: './bag-drawer.component.html'
})
export class BagDrawerComponent {
  private readonly bagUi = inject(BagUiService);
  readonly cart = inject(CartService);

  readonly isEmpty = computed(() => this.cart.items().length === 0);

  close(): void {
    this.bagUi.hide();
  }

  increment(line: CartLine): void {
    this.cart.increment(line.id);
  }

  decrement(line: CartLine): void {
    this.cart.decrement(line.id);
  }

  remove(line: CartLine): void {
    this.cart.remove(line.id);
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.bagUi.open()) {
      this.close();
    }
  }
}
